/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Meta_DescriptionInputs */

const en_history_meta_description = /** @type {(inputs: History_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your recent creations and their status.`)
};

const es_history_meta_description = /** @type {(inputs: History_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus creaciones recientes y su estado.`)
};

/**
* | output |
* | --- |
* | "Your recent creations and their status." |
*
* @param {History_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const history_meta_description = /** @type {((inputs?: History_Meta_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Meta_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_history_meta_description(inputs)
	return es_history_meta_description(inputs)
});